import { render, staticRenderFns } from "./videoBottomTab.vue?vue&type=template&id=39b2a4d8&scoped=true&"
import script from "./videoBottomTab.vue?vue&type=script&lang=js&"
export * from "./videoBottomTab.vue?vue&type=script&lang=js&"
import style0 from "./videoBottomTab.vue?vue&type=style&index=0&id=39b2a4d8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39b2a4d8",
  null
  
)

export default component.exports